import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import filterFactory from 'react-bootstrap-table2-filter';

import "./Delegates.css";
import UITableUtils from "../util/UITableUtils";
import CollapsibleNote from "../base/CollapsibleNote";

import INotes from "./INotes";
import ITooltip from "./ITooltip";
import UIUtils from "../util/UIUtils";
import LogoUtils from "../util/LogoUtils";
import ApiUtils from '../util/ApiUtils';
import Utilities from "../util/Utilities";
import SPUtilities from "../util/SPUtilities";
import FavUtils from "../util/FavUtils";
import RespUtils from "../util/RespUtils";

import IUtils from "./IUtils";
import IRewardUtils from "./IRewardUtils";
import DelInline from "./DelInline";
import NetworkHeader from "./NetworkHeader";
import Special from '../components/Special';

class Delegates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      delegates: [],
      coinStat: {},
      statusSummary: {},
      hermesInd: "",
      notification: {"message": null},
      width: window.innerWidth,
      size: 10,
      lastUpdated: "",
      isLoading: true,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
    this.reload = this.reload.bind(this);
    this.favourite = this.favourite.bind(this);
    this.unfavourite = this.unfavourite.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    // var delegateId = UIUtils.getNodeId(this);
    let url = "listData?type=listDelegates"

    if (this.props.match && this.props.match.params.status) {
      url += "&status=" + this.props.match.params.status;
    } else {
      url += "&status=AllDel";
    }
    // console.log(url);

    const allData = await ApiUtils.get(url);
    // console.log(allData)
    if (!allData) {
      this.setState({error: true, isLoading: false});
      return;
    }

    let delegates = allData["data"];
    let lastUpdated = allData["lastUpdated"];
    if (delegates) {
      let newDelegates = Utilities.addIndex(delegates);
      let finalData = FavUtils.filterData(this, newDelegates);

      let newLastUpdated = lastUpdated;
      if (lastUpdated == null) {
        newLastUpdated = 0;
      }

      let notification = allData["notification"];
      let statusSummary = allData["statusSummary"];
      let coinStat = allData["coinStat"];
      this.setState({lastUpdated: newLastUpdated, notification: notification,
        statusSummary: statusSummary, delegates: finalData, coinStat: coinStat,
        hermesInd: allData["hermesInd"]});
    }

    this.setState({isLoading: false});
  }

  unfavourite(e) {
    FavUtils.unfavourite(e, this);
  }

  favourite(e) {
    FavUtils.favourite(e, this);
  }

  render() {
    let loadMsg = UIUtils.getLoading(this);
    if (loadMsg) return loadMsg;

    var columns;
    // {text: "Perf", dataField: "productivity", sort: true, formatter: IUtils.productivityFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
    if (RespUtils.isMobileView()) {
      columns = [
        {text: "",dataField: "delegateId", sort: true, formatter: FavUtils.favoriteFormatter, formatExtraData: this, headerStyle: Utilities.width(5)},
        {text: "#", dataField: "ranking", sort: true, headerStyle: Utilities.width(8)},
        {text: "Name", dataField: "name", formatter: IUtils.nameFormatterShort, formatExtraData: this.state.hermesInd, sort: true, headerStyle: Utilities.width(20)},
        {text: "Votes", dataField: "totalWeightedVotes", sort: true, formatter: SPUtilities.stakeFormatterRounded, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(18)},
        {text: "Status", dataField: "overallStatus", formatter: IUtils.statusFormatter, sort: true, headerStyle: Utilities.width(18)},
        {text: "Prod Rate", dataField: "longProdRate", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8), title: ITooltip.prodRateTip},
        // {text: "Prod Index", dataField: "longProdIndex", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(17)},
        // {text: "Net APR", dataField: "netApr", sort: true, formatter: IUtils.percentFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
      ];
    } else if (RespUtils.isTabletView()) {
      columns = [
        {text: "",dataField: "delegateId", sort: true, formatter: FavUtils.favoriteFormatter, formatExtraData: this, headerStyle: Utilities.width(3)},
        {text: "#", dataField: "ranking", sort: true, headerStyle: Utilities.width(4)},
        {text: "",dataField: "logo", sort: true, formatter: LogoUtils.formatLogo, headerStyle: Utilities.width(4)},
        {text: "Name", dataField: "name", formatter: IUtils.nameFormatter, formatExtraData: this.state.hermesInd, sort: true, headerStyle: Utilities.width(20)},
        {text: "Votes", dataField: "totalWeightedVotes", sort: true, formatter: SPUtilities.stakeFormatterRounded, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(14)},
        {text: "Status", dataField: "overallStatus", formatter: IUtils.statusFormatter, sort: true, headerStyle: Utilities.width(15)},
        {text: "Net Apr", dataField: "netApr", sort: true, formatter: IUtils.percentFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
        {text: "91D Daily Reward /10k", dataField: "rewardPercentPerDay", sort: true, formatter: IRewardUtils.get91DayDailyReward10k, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
        // {text: "Reward /day /10k", dataField: "rewardPercentPerDay", sort: true, formatter: IRewardUtils.rewardPerDay, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(13)},
        // {text: "1 Day Prod Index (PI)", dataField: "dailyProdIndex", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(17)},
        {text: "Production Rate", dataField: "longProdRate", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8), title: ITooltip.prodRateTip},
        // {text: "Production Index", dataField: "longProdIndex", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
        // {text: "Current Prod.", dataField: "productivity", sort: true, formatter: IUtils.productivityFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
      ];
    } else {
      columns = [
        {text: "#", dataField: "ranking", style: IUtils.consensusStyleFormatter, sort: true, headerStyle: Utilities.width(3)},
        {text: "",dataField: "delegateId", sort: true, formatter: FavUtils.favoriteFormatter, formatExtraData: this, headerStyle: Utilities.width(3)},
        {text: "",dataField: "logo", sort: true, formatter: LogoUtils.formatLogo, headerStyle: Utilities.width(3)},
        {text: "Name", dataField: "name", formatter: IUtils.nameFormatter, formatExtraData: this.state.hermesInd, sort: true, headerStyle: Utilities.width(14)},
        // {text: "Self Bond", dataField: "selfBond", sort: true, formatter: IUtils.coinCountCellFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(9)},
        {text: "Live Votes", dataField: "totalWeightedVotes", sort: true, formatter: IUtils.coinCountCellFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8)},
        // {text: "Vote Weight", dataField: "percent", formatter: IUtils.percentFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(6)},
        {text: "Rewards Method", dataField: "hermesInd", formatter: IUtils.rewardsFormatter, formatExtraData: this.state.hermesInd, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8)},
        {text: "Status", dataField: "overallStatus", formatter: IUtils.statusFormatter, sort: true, headerStyle: Utilities.width(8)},
        {text: "Blended Share %", dataField: "blendedShare", sort: true, formatter: IUtils.percentFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7), title: ITooltip.blendedShareTip},
        {text: "Net Apr", dataField: "netApr", sort: true, formatter: IUtils.percentFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(6), title: ITooltip.blendedShareTip},
        // {text: "91 Day Net Apr", dataField: "netApr", sort: true, formatter: IRewardUtils.get91DayWeightedApr, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "Daily Reward (10k)", dataField: "rewardPercentPerDay", sort: true, formatter: IRewardUtils.rewardPerDay, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(9), title: ITooltip.rewardPercentTip},
        {text: "91 Day Daily Reward (10k)", dataField: "rewardPercentPerDay", sort: true, formatter: IRewardUtils.get91DayDailyReward10k, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10), title: ITooltip.rewardPercentTip},
        // {text: "30 Days Part Rate", dataField: "longElectionRate", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8)},
        {text: "Production Rate", dataField: "longProdRate", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8), title: ITooltip.prodRateTip},
        {text: "Production Index", dataField: "longProdIndex", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(8), title: ITooltip.prodIndexTip},
        // {text: "Block Reward %", dataField: "blockRewardPortion", sort: true, formatter: IUtils.getRewardShare, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        // {text: "Epoch Reward %", dataField: "epochRewardPortion", sort: true, formatter: IUtils.getRewardShare, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        // {text: "Foundation Reward %", dataField: "foundationRewardPortion", sort: true, formatter: IUtils.getRewardShare, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(9)},
        // {text: "1 Day PI", dataField: "dailyProdIndex", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(5)},
        // {text: "8 Hr PI", dataField: "shortProdIndex", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(9)},currentProductivityTip
        {text: "Current Productivity", dataField: "productivity", formatter: IUtils.productivityFormatter, headerStyle: Utilities.width(9), title: ITooltip.currentProductivityTip},
        {text: "Vote", dataField: "id", sort: false, formatter: IUtils.voteFormatter, headerStyle: Utilities.width(6)},
      ];
    }
    // {text: "Fee", dataField: "blendedFee", sort: true, formatter: IUtils.percentFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
    // {text: "Blended Fee", dataField: "blendedFee", sort: true, formatter: IUtils.percentFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
    // {text: "Blended Fee", dataField: "blendedFee", sort: true, formatter: IUtils.percentFormatter, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},

    const options = {
      onlyOneExpanding: true
    };

    let specialMessage = "";
    if (window.innerWidth < 600) {
      specialMessage = "Tip: This screen is best viewed in landscape mode (Rotate your mobile device for a better view)";
    }

    const expandRow = {
      renderer: row => (
        <div>
          <DelInline delegate={row} coinStat={this.state.coinStat} hermesInd={this.state.hermesInd} />
          <hr/>
        </div>
      ), showExpandColumn: false
    };

    let lastUpdated = this.state.lastUpdated ? (this.state.lastUpdated/60).toFixed(0) : "N/A";
    let wrapperClasses = UITableUtils.isDefaultView() ? "table":"table-responsive";

    // Try our telegram bot <a target="_blank" class="black-a" href="https://t.me/IoTeXAnalyticsBot">IoTeXAnalyticsBot</a>.
    // <span className="buttonWithText">{FavUtils.showFavSwitch()}&nbsp;<img src="/images/reload.svg" onClick={this.reload} title="Reload Screen"
    //   className="imgicon" width="32" height="32" /></span>

    // If you know of delegates that are underpaying/not paying/have different rewards plan than shown, please provide feedback via telegram. <span style={{"backgroundColor": "orange"}}>All rewards/APRs shown here are theoretical and not based on actual performance.</span>
    return (
      <div>
        <Special />
        <p/>
        <h4 style={{align: "center"}}><span><strong>Delegates</strong></span>
            {UIUtils.renderPageActions(this, true, true)}
        </h4>
        <NetworkHeader coinStat={this.state.coinStat} />
        <p>Last updated - <b>{lastUpdated}</b> minutes ago. Try our telegram bot <a target="_blank" class="black-a" href="https://t.me/IotexAnalyticsBot">IotexAnalyticsBot</a>.</p>
        {this.renderStatusTags()}
        {UIUtils.getNotification(this.state.notification)}
        <p/>
        <BootstrapTable keyField='delegateId' data={ this.state.delegates } filter={ filterFactory() }
          columns={ columns } hover striped expandRow={ expandRow }
          expandableRow={ () => { return true; } } rowStyle={UITableUtils.getMainTableRowStyle}
          condensed noDataIndication="Table is Empty/Loading" wrapperClasses={wrapperClasses}
          />
        <p/>

        {/* <p/>{IUtils.getSupportUs()} */}
        <CollapsibleNote getScreenGuide={INotes.getPoolNote} />
        {specialMessage}
      </div>
    );
  }

  // <td className="view-tag"><a href={"/delegates/AllEligible"}>{this.formatView("All elig " + (this.state.statusSummary.Elected + this.state.statusSummary.Eligible), "AllEligible")}</a> </td>
  // <td className="view-tag"><a href={"/delegates/InConsensus"}>{this.formatView("In Consensus " + this.state.statusSummary.InConsensus, "InConsensus")}</a> </td>
  // <p>Legend - <font style={{ backgroundColor: 'gainsboro' }}>Favorite</font>
  //   &nbsp;&nbsp;<font style={{ backgroundColor: 'oldlace'}}>Not eligible at this time for election in next epoch</font>
  // </p>
  // <br/>* - IoTeX recommends voting with delegates that use Hermes service for rewards distribution. Delegates with name ending in * <b>do not</b> use Hermes.

  renderStatusTags() {
    if (this.state.isLoading) return "";

    if (RespUtils.isTabletView()) {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a className="white-a" href={"/delegates/AllDel"}>{this.formatView("All " + this.state.statusSummary.AllDel, "AllDel")}</a> </td>
          <td className="view-tag"><a className="white-a" href={"/delegates/Elected"}>{this.formatView("Elec " + this.state.statusSummary.Elected, "Elected")}</a> </td>
          <td className="view-tag"><a className="white-a" href={"/delegates/Eligible"}>{this.formatView("Elig " + this.state.statusSummary.Eligible, "Eligible")}</a> </td>
          <td className="view-tag"><a className="white-a" href={"/delegates/NotEligible"}>{this.formatView("Not Elig " + this.state.statusSummary.NotEligible, "NotEligible")}</a> </td>
          <td className="view-tag"><a className="white-a" href={"/delegates/Probated"}>{this.formatView("Probated + " + this.state.statusSummary.Probated, "Probated")}</a> </td>
        </tr></tbody></table></div>);
    } else {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a className="white-a" href={"/delegates/AllDel"}>{this.formatView("All - " + this.state.statusSummary.AllDel, "AllDel")}</a> </td>
          <td className="view-tag"><a className="white-a" href={"/delegates/Elected"}>{this.formatView("Elected - " + this.state.statusSummary.Elected, "Elected")}</a> </td>
          <td className="view-tag"><a className="white-a" href={"/delegates/Eligible"}>{this.formatView("Eligible - " + this.state.statusSummary.Eligible, "Eligible")}</a> </td>
          <td className="view-tag"><a className="white-a" href={"/delegates/NotEligible"}>{this.formatView("Not Eligible - " + this.state.statusSummary.NotEligible, "NotEligible")}</a> </td>
          <td className="view-tag"><a className="white-a" href={"/delegates/Probated"}>{this.formatView("Probated - " + this.state.statusSummary.Probated, "Probated")}</a> </td>
        </tr></tbody></table></div>);
    }
  }

  formatView(label, status) {
    // console.log("in formatView for: ", label, status);
    if (this.props.match && this.props.match.params.status) {
      if (this.props.match.params.status == status) {
        // console.log("status matched: ", this.props.match.params.status, status);
        return <b><u>{label}</u></b>
      } else {
        return label;
      }
    } else if (status == "AllDel") {
      // console.log("returning from AllEligible");
      return <b><u>{label}</u></b>
    } else if (status != null) {
      // console.log("returning from status not null");
      return label;
    }

    // console.log("returning from end");
    return <b><u>{label}</u></b>
  }

  reload() {
    window.location = "/";
  }
}

export default Delegates;

// use this for in consensus
// #grad {
//   background-image: linear-gradient(to right, red , yellow);
// }



// WEBPACK FOOTER //
// ./src/iotex/Delegates.js